import React from 'react'

const AudioNotFound: React.FC<{ text?: string }> = ({ text }) => {
  const message = text || "I couldn't hear your response, could you try again."
  return (
    <div className="flex h-full w-full items-center justify-center bg-[rgba(31,209,103,0.05)]">
      <div className="relative mt-2 flex w-full max-w-[360px] flex-col items-center justify-center py-8 px-6 md:h-[40%]">
        <div className="flex w-full max-w-[350px] flex-col items-center gap-4">
          <div className="flex flex-col gap-2 items-center py-2 px-4 max-w-[300px] w-full bg-white rounded-sm justify-center ">
            <p className="text-center font-ubuntu text[14px] text-slate-900">{message}</p>
            <p className="text-center font-ubuntu text-[12px] text-slate-500">When ready, speak and press Done again.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AudioNotFound
